import type { QuestionOptions } from "../types";

type FieldType = {
	field: string;
	transform: (value: string) => unknown;
};

export const KEY_ANSWER: Record<QuestionOptions, FieldType> = {
	Option: {
		field: "valueOptions",
		transform: (v) => {
			if (!v) {
				return [];
			}
			// Se for array (multi-select), converte cada item
			if (Array.isArray(v)) {
				return v.map((item) =>
					typeof item === "string" ? Number(item) : item
				);
			}
			// Se for string única (single select)
			return [typeof v === "string" ? Number(v) : v];
		},
	},
	Date: {
		field: "valueDateTime",
		transform: (v) => new Date(v),
	},
	Time: {
		field: "valueDateTime",
		transform: (v) => {
			if (!v) {
				return null;
			}
			if (typeof v === "string" && v.includes("T")) {
				return new Date(v);
			}
			const [hoursStr, minutesStr = "0"] = String(v).split(":");
			const hours = Number(hoursStr || 0);
			const minutes = Number(minutesStr || 0);
			const base = new Date();
			base.setSeconds(0, 0);
			base.setHours(hours, minutes, 0, 0);
			return base;
		},
	},
	DateTime: {
		field: "valueDateTime",
		transform: (v) => new Date(v),
	},
	Text: {
		field: "valueText",
		transform: (v) => v,
	},
	Number: {
		field: "valueNumber",
		transform: (v) => {
			if (v === undefined || v === null) {
				return null;
			}
			const trimmed = String(v).trim();
			if (trimmed === "" || trimmed === "undefined" || trimmed === "null") {
				return null;
			}
			const parsed = Number(trimmed);
			if (Number.isNaN(parsed)) {
				return null;
			}
			return parsed;
		},
	},
	File: {
		field: "valueFiles",
		transform: (v) => JSON.parse(v),
	},
	Boolean: {
		field: "valueBoolean",
		transform: (v) => (typeof v === "boolean" ? v : v === "true"),
	},
};
